// 这是路由展示组件 当路由跳转到'/pluginUploadFiles'的时候展示的组件 也就是多文件上传的组件
import React, { useEffect, useCallback, useState, useRef } from "react";
import styled from "styled-components";
import UploadFilesTable from "./uploadFilesTable";
import Title from "./title";
import PaginationNav from "./paginationNav";
import data from "services/data";
import ToolsBar from "./toolsBar";
import logger from "utils/logger";
import PluginInfoModal from "./modals/pluginInfoModal";
import ConfirmModal from "./modals/confirmModal";
import { useHistory } from "react-router-dom";
import notifier from "utils/notifier";
import {faFileDownload,faFileExcel,faSpinner,faFileWord,faTimes} from '@fortawesome/free-solid-svg-icons';



const StyledPluginInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const StyledMain = styled.main`
  background-color: ${({ theme }) => theme.secondBackgroundColor};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 50px;
`;

const StyledSection = styled.section`
  width: 100%;
  min-height: 430px;
  word-wrap: break-word;
  text-align: justify;

  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

// 定义文件上传的包含框样式
const StyledUploadContainer = styled.div`
  display: flex;
  height: 400px;
  align-items: center;
  justify-content: center;
  background-color: #eee;
`

const tablePageSize = 18;

const PluginUploadFiles = ({ user }) => {
  // const [total, setTotal] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [items, setItems] = useState([]);
  const [modalVisible, setModalVisible] = useState({
    pluginInfoModal: false,
    confirmModal: false,
  });
  const [modalType, setModalType] = useState("");
  const [currentPlugin, setCurrentPlugin] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  // const history = useHistory();

  const fileUpload = useRef(null)
  // 定义用来存储页面展示的json文件和对应的zip依赖文件
  const [josnFileShow,setJsonFileShow] = useState([])
  const [zipFileShow,setZipFileShow] = useState([])
  // 用来存储json文件中读取的内容
  const [jsonContentShow,setJsonContentShow] = useState([])
  // 用来存储文件上传的状态
  // let uploadStatus = {icon:[faFileDownload, faFileExcel],status:0,title:'未上传'}
  const [uploadStatus,setUploadStatus] = useState({icon:[faFileDownload,faSpinner,faFileWord,faFileExcel,faTimes],status:[],title:['未上传','上传中','上传完成','文件上传失败','版本发布失败']})

  const closeAllModal = useCallback(() => {
    setModalVisible({});
    // 清空错误信息
    setErrorMessage("");
  }, []);

  // 当页数发生改变的时候
  // const handleCurrentPageChange = useCallback((pageNum) => {
  //   setCurrentPage(pageNum);
  // }, []);
  // const updateItems = useCallback(
  //   async (pageSize, currentPage) => {
  //     const { totalCount, pluginList } = await data.getPluginInfoList(
  //       pageSize,
  //       currentPage,
  //       keyword
  //     );
  //   //   setItems(pluginList);
  //     setTotal(totalCount);
  //   },
  //   [keyword]
  // );

  // const handleSearch = useCallback(() => {
  //   if (currentPage === 1) {
  //     updateItems(tablePageSize, 1);
  //   } else {
  //     setCurrentPage(1);
  //   }
  // }, [currentPage, updateItems]);


  // 删除已经上传的文件
  const handlePluginDelete =  () => {
    // 点击确认删除按钮之后，可以拿到要删除的插件的信息，根据这个信息删除对应的插件
    const newItems = items.filter( (item) => {
      console.log(item.app_id + item.os_version,currentPlugin.app_id + currentPlugin.os_version);
      return (item.app_id + item.os_version) !== (currentPlugin.app_id + currentPlugin.os_version)
    })
    setItems(newItems)
    // 再进行删除操作之后进行展示文件的数组也要跟着改变
    const newJsonFile = josnFileShow.filter( (jsonFile) => {
      return (currentPlugin.fileName + '.json') !== jsonFile.name
    })
    const newZipFile = zipFileShow.filter( (zipFile) => {
      return (currentPlugin.fileName + '.zip') !== zipFile.name
    })
    const newJsonContent = jsonContentShow.filter( (jsonContent) => {
      return (currentPlugin.fileName) !== jsonContent.fileName
    })
    setJsonFileShow(newJsonFile);
    setZipFileShow(newZipFile);
    setJsonContentShow(newJsonContent);
    // 完成删除之后关闭模态框
    closeAllModal();
    console.log('要删除即将上传的文件',currentPlugin);
  }

  // useEffect(() => {
  //   // 获取和根据currentPage更新列表
  //   updateItems(tablePageSize, currentPage);
  // }, [currentPage]);

  // 代理input输入框的点击事件，弹出一个选择文件的框
  const handleIptClick = () => {
    // 相当于点击了input 文件框来选择文件，因为input默认样式太丑，所以使用代理的方式实现点击
    fileUpload.current.click();
  }

  // 选择文件之后的回调函数(或者拖拽文件上传的回调函数)  对上传的文件进行筛选，全部都要是成对出现，一个zip文件匹配一个json版本信息文件，不符合条件的过滤出去并且在控制台打印输出
  const handleIptChange = (e) => {
    let FileList = null
    // 用来判断是拖拽文件上传还是点击文件上传
    if(e.dataTransfer) {
      // 把上传文件的对象转化为数组对象，数组中包含着一个一个的对象，每个对象就是一个选中的文件
      FileList = Array.from(e.dataTransfer.files);
    }else {
      FileList = Array.from(e.target.files);
    }
    console.log("上传的文件对象转化成的数组", FileList);
    // zipList 用来存储所有上传的zip文件  josnList 用来存储所有上传的json文件
    const zipList = [];
    const jsonList = [];
    FileList.forEach( (item) => {
      const arr = item.name.split('.');
      // 拿到文件的后缀，只有是zip的才去判断有没有对应的json文件，如果存在就是成功否则失败
      // 把所有需要判断是否含有json的zip文件放在一个数组中
      if(arr[arr.length - 1] === 'zip' || arr[arr.length - 1] === 'bvpk') {
        const isZip = arr[arr.length - 1] === 'zip'
        // 拿到除了后缀之外的所有数组拼接成的字符串
        zipList.push({value: arr.slice(0,arr.length - 1).join('.'), name: isZip ? '.zip' : '.bvpk'});
      } else if(arr[arr.length - 1] === 'json') {
        jsonList.push(arr.slice(0,arr.length - 1).join('.'));
      }
    })
    // showList 就是同时包含 zip文件和json文件的依赖的文件名 字符串(不包含后缀)
    let showList = [...new Set(zipList)].filter(item => 
      jsonList.includes(item.value)
    )
    const showJsonList = showList.map( (item) => {
      return item.value + '.json';
    })
    const showZipList = showList.map( (item) => {
      return item.value + item.name;
    })
    // 根据showList 中的字符串来筛选出真正的json文件，showFileList 就是存放真正json文件的数组，下一步就是把该数组中的所有json文件中的内容读取出来并且展示到页面
    // 用来接收所有的符合条件的zip依赖文件的数组
    const zipFilesList = []
    // noShowList 是用来存放已经选择的但是不符合要求的文件
    const noShowFile = [];
    const showFileList = FileList.filter( (file) => {
      const fileNameList = file.name.split('.');
      // fileNameList 数组中存储的是上传文件使用 . 分割的所有字符串， 然后把后缀名去除再和showList比较是否包含，这样就是只要是出现在showList中的文件，不管是zip还是json文件都不会被过滤
      if(!showList.includes(fileNameList.slice(0,fileNameList.length - 1).join('.'))) noShowFile.push(file);
      if(showZipList.includes(file.name)) zipFilesList.push(file)
      return showJsonList.includes(file.name);
    })
    console.log('符合要求的json文件为',showFileList);
    console.log('符合要求的zip文件为',zipFilesList);
    console.log('不符合要求的文件为',noShowFile);
    // 存储符合条件的json文件和zip文件到State
    setJsonFileShow(showFileList)
    setZipFileShow(zipFilesList)

    // 2.对于筛选之后的数组进行读取，把对应的json文件中的信息读取出来并且展示到页面
    // 符合条件的数组放在页面展示
    // 定义一个数组用来存放json文件中的内容的对象  GjsonContentList 是全局定义的State
    const jsonContentList = [];
    // 用来接收所有文件读取返回Promise对象的数组
    const resultReadFile = [];
    // 读取所有的json文件中的内容并展示在页面
    showFileList.forEach( (file) => {
      const p = new Promise((resolve,reject) => {
        const reader = new FileReader();
        // 异步处理文件数据
        reader.readAsText(file, 'UTF-8');
        // 如果文件读取失败返回错误的信息
        if(reader.error)  return reject(notifier.error(reader.error.message))
        // 处理完成后立马触发 onload
        reader.onload = fileReader => {
            const fileData = fileReader.target.result;
            const jsonText = JSON.parse(fileData);
            // 添加系统版本信息
            const os_versionName = file.name.split('-').filter( (item) => {
              if(item === 'windows' || item === 'linux' || item === 'all' || item === 'arm64') return true
            })
            jsonText.os_version = os_versionName.join('-')
            const delSuffix = file.name.split('.')
            jsonText.fileName = delSuffix.slice(0,delSuffix.length - 1).join('.')
            jsonContentList.push(jsonText);
            resolve();
        };
      })
      resultReadFile.push(p);
    })
    setUploadStatus({icon:[faFileDownload,faSpinner,faFileWord,faFileExcel,faTimes],status:[],title:['未上传','上传中','上传完成','文件上传失败','版本发布失败']})
    // 把读取出来的符合要求的json文件中的内容展示到页面, 只有当所有的文件都读取成功的时候才在页面进行显示
    Promise.all(resultReadFile).then( () => {
      // console.log(jsonContentList); jsonContentList就是符合条件的json文件的内容对象的数组
      // 把符合条件的json文件中的内容展示到页面
      setItems(jsonContentList);
      setJsonContentShow(jsonContentList)
    })
  }

  // 点击发布按钮之后的处理函数
  const handleButtonClick = async () => {
    // 点击了发布之后就会把对应的文件上传到服务器 然后再把对应的文件版本添加到对应的插件中，生成版本
    console.log("点击了发布");
    console.log('json',josnFileShow);
    console.log('zip',zipFileShow);
    console.log('content',jsonContentShow);
    if(!josnFileShow.length) return notifier.error('请上传版本文件')
    // 设置默认的状态是0，也就是未上传的状态，这个数组用来存储各个文件的状态
    let statusArr = new Array(zipFileShow.length).fill(0)
    for(let i = 0; i < zipFileShow.length; i++) {
      let status = 1;
      statusArr[i] = status;
      setUploadStatus(uploadStatus => ({...uploadStatus,status:statusArr,statusPosition:i}));
      // 根据jsonContentShow对要上传的zip文件进行一次比较，防止错乱的问题出现，把内容和zip绑定在一起
      const resultFileZip = zipFileShow.filter( (item) => {
        return item.name === jsonContentShow[i].fileName + '.zip' || item.name === jsonContentShow[i].fileName + '.bvpk'
      })
      if(resultFileZip.length === 0 ) return notifier.error('有错乱出现，未匹配到对应的zip文件！')
      status = await data.uploadVersionFile(resultFileZip[0],jsonContentShow[i]);
      // 根据这里返回的状态来判断文件上传处于的阶段,每个文件的状态发生变化的时候就改变对应的状态
      // uploadStatus = {icon:[faFileDownload, faFileExcel],status: 1,title:'已上传',statusPosition:i}
      // setUploadStatus({icon:[faFileDownload, faFileExcel],status: 1,title:'已上传',statusPosition:i});
      statusArr[i] = status;
      setUploadStatus(uploadStatus => ({...uploadStatus,status:statusArr,statusPosition:i}));
    }
  }
  // 实现文件拖拽上传功能的函数
  function dragEnter(e){
      e.stopPropagation();
      e.preventDefault();
      console.log(e.target.className);
      if(e.target.className.includes('uploadContainer')) {
        e.target.style.border = '1px dashed #000'
      }
  }

  function dragOver(e){
      e.stopPropagation();
      e.preventDefault();
  }
  function dragLeave(e) {
    e.stopPropagation();
    e.preventDefault();
    if(e.target.className.includes('uploadContainer')) {
      e.target.style.border = 'none'
    }
  }
  function drop(e){
    e.preventDefault()
    if(e.target.className.includes('uploadContainer')) {
      e.target.style.border = 'none'
    }
    // 当文件拖拽到dropBox区域时,可以在该事件取到files
    handleIptChange(e)
  }
  return (
    <StyledPluginInfo>
      <StyledMain>
        <Title title="批量发布版本" />
        <StyledSection>
          <ToolsBar
            auth={!!user}
            tools={[]}
            search={{
              value: keyword,
              setValue: setKeyword,
              // onSearch: handleSearch,
            }}
            totalFileNum = {josnFileShow.length}
            hasButton = {true}
            buttonContent="发布"
            // 点击发布按钮之后的处理函数
            handleButtonClick = {handleButtonClick}
          />
          <UploadFilesTable
            mode="normal"
            items={items}
            heads={["名称","版本号","系统版本","编译时间","版本信息","desc","状态"]}
            paths={["module","version","os_version","build_time", "change_info","change_info_en","status"]}
            showTools={!!user}
            auth={!!user}
            icon={uploadStatus}
            tools={[
              {
                type: "remove",
                onClick: (data) => {
                  setModalType("");
                  setModalVisible({ confirmModal: true });
                  logger.log("点击了删除 当前点击的插件：", data);
                  setCurrentPlugin(data);
                },
              },
            ]}
            rowCursor="pointer"
            files={{zipFileShow,jsonContentShow}}
          />
            {/* 文件上传的区域 */}
          <StyledUploadContainer
            className="uploadContainer"
            onDragEnter={dragEnter}
            onDragOver={dragOver}
            onDrop={drop}
            onDragLeave={dragLeave}
          >
            <div 
              style={{position: 'absolute',display:'flex',width: '200px',height:'200px',border:'1px dashed gray',alignItems:'center',justifyContent:'center',flexDirection:'column',color:'#555',cursor:'pointer'}} 
              type="file" 
              onClick={ handleIptClick }
            >
              <input type="file" ref={fileUpload} style={{ display: 'none'}} onChange={ handleIptChange } multiple/>
              <span style={{fontSize: '40px',lineHeight:"30px"}}>+</span>
              <span style={{margin: '10px 0'}}>点击上传</span>
              <span>(或拖拽至此)</span>
            </div>
          </StyledUploadContainer>
        </StyledSection>
      </StyledMain>
      {/* <PaginationNav
        total={total}
        pageSize={tablePageSize}
        currentPage={currentPage}
        onCurrentPageChange={handleCurrentPageChange}
      /> */}
      <PluginInfoModal
        errorMessage={errorMessage}
        visible={modalVisible.pluginInfoModal}
        type={modalType}
        displayTargetPlugin
        data={currentPlugin}
        onClose={closeAllModal}
      />
      <ConfirmModal
        errorMessage={errorMessage}
        visible={modalVisible.confirmModal}
        onClose={closeAllModal}
        title="提示"
        content="确定要删除该版本？"
        confirmLabel="删除"
        cancelLabel="取消"
        confirmType="danger"
        onConfirm={handlePluginDelete}
        onCancel={closeAllModal}
      />
    </StyledPluginInfo>
  );
};

export default PluginUploadFiles;
